import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Planning, Room } from "../types";

export const createRoomQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (buildingId: string): Promise<Room[]> => {
    const { data, error } = await client.GET(`/buildings/{buildingId}/rooms`, {
      params: { path: { buildingId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const plannings = async (roomId: string): Promise<Planning[]> => {
    const { data, error } = await client.GET(`/rooms/{roomId}/plannings`, {
      params: { path: { roomId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  return {
    list,
    plannings,
    queries: createQueryKeys("room", {
      building: (buildingId: string) => ({
        queryKey: [buildingId],
        queryFn: () => list(buildingId),
      }),
      plannings: (roomId: string) => ({
        queryKey: [roomId, "planning"],
        queryFn: () => plannings(roomId),
      }),
    }),
  };
};
